import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Title = styled.h3`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  border-radius: ${props => props.theme.borderRadius.default};
  color: ${props => props.titleColor || props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${props =>
    props.theme.isBackground &&
    css`
      background: ${props => props.titleBackground || props.theme.background};
    `}


  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Spacer = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background: ${props => props.theme.background};
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-gap: ${props => props.theme.gridGap.default};
  padding: ${props => props.theme.padding.default};

  ${Media.md`
    grid-gap: ${props => props.theme.gridGap.md};
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Text = styled.div`
  display: block;
  max-width: 100%;
  text-align: justify;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Item = styled.div`
  display: block;
  width: 100%;
  margin: ${props => props.theme.margin.default};

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  display: block;
  width: 250px;
`;
export const LabelDiv = styled.div`
  display: block;
  width: 100%;
`;
export const ButtonReadLess = styled.button`
  border: 0;
  background-color: transparent;
  margin-left: 25px;
  cursor: pointer;
  margin-top: -20px;
  outline: none;
  &:hover {
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};
  }
`;

export const Textarea = styled.textarea`
  display: block;
  width: 100%;
  min-height: 120px;
  transition: 0.2s all;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  border: 1px solid ${props => props.theme.border};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  box-shadow: ${props => props.theme.boxShadow};
  resize: vertical;
  -webkit-appearance: none;
  cursor: text;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
  &::placeholder {
    color: ${props => props.theme.placeholderColor || 'inherit'};
  }
`;
export const Emailarea = styled.input`
  display: block;
  width: 100%;
  min-height: 40px;
  margin-bottom:5px;
  transition: 0.2s all;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  border: 1px solid ${props => props.theme.border};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  box-shadow: ${props => props.theme.boxShadow};
  resize: vertical;
  -webkit-appearance: none;
  cursor: text;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
  &::placeholder {
    color: ${props => props.theme.placeholderColor || 'inherit'};
  }
`;
export const CheckboxLabel = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: justify;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  cursor: pointer;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Checkbox = styled.span`
  position: relative;
  display: block;
  flex-shrink: 0;
  height: 18px;
  width: 18px;
  margin: 0 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  transition: 0.2s all;
  border: 1px solid ${props => props.theme.border};
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  box-shadow: ${props => props.theme.boxShadow};
  outline: none;
  cursor: pointer;
`;

export const CheckboxInput = styled.input`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  display: block;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
`;

export const CheckboxCheckmark = styled.i`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  transition: 0.2s all;
  opacity: 0;
  font-size: 16px;
  cursor: pointer;

  ${props =>
    props.visible &&
    css`
      opacity: 1;
    `}
`;

export const ButtonHolder = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${props => props.theme.justifyContent || 'center'};
  border-bottom: ${props => props.theme.border};
  border-color: ${props => props.theme.borderColor};
`;

export const Button = styled.button`
  display: block;
  width: auto;
  flex-shrink: 0;
  transition: 0.2s all;
  border: 0; 
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: pointer;

  min-width: ${props => props.theme.minHeight || '88px'};  
  height: ${props => props.theme.minHeight || '31px'};
  border-radius: ${props => props.theme.minHeight || '4px'};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:hover {
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};
  }
`;
